import {useContext} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {CustomerReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerReportsHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {handleCustomerGroupReportDateChange, handleCustomerTypeReportDateChange} =
    useContext(CustomerReportContext)

  return (
    <div className='d-flex flex-wrap justify-content-end align-items-center mb-10'>
      <PredefinedDateRange
        cb={(startDate, endDate) => {
          handleCustomerGroupReportDateChange(startDate, endDate)
          handleCustomerTypeReportDateChange(startDate, endDate)
        }}
        defaultValue={dateRangeLabel || 'Last 90 Days'}
        includeCurrantDay
        startDate={MIN_DATE_RANGE}
      />
    </div>
  )
}
export {CustomerReportsHeader}
